import React from 'react';
import styles from './CTAContent.module.css';
import Button from '../../../../components/common/Button/Button';

/**
 * @component CTAContent
 * @description CTA 섹션 텍스트 및 버튼 영역
 * - z-index: 2 (오버레이 위 최상단)
 */
function CTAContent({ title, subtitle, buttons, onActorClick, onProducerClick }) {
  return (
    <div className={styles.ctaContent}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.subtitle}>{subtitle}</p>
      <div className={styles.buttonGroup}>
        <Button
          variant={buttons.actor.variant}
          size="medium"
          icon={buttons.actor.icon}
          iconPosition="right"
          onClick={() => onActorClick(buttons.actor.action)}
        >
          {buttons.actor.label}
        </Button>
        <Button
          variant={buttons.producer.variant}
          size="medium"
          icon={buttons.producer.icon}
          iconPosition="right"
          onClick={() => onProducerClick(buttons.producer.action)}
        >
          {buttons.producer.label}
        </Button>
      </div>
    </div>
  );
}

export default CTAContent;
